import { SessionResponse } from '../../models/responses/SessionResponse';
import { deleteRequest, patchRequest } from './wamazingApi';

const path = '/v1/auth/sessions';
const resource = 'secure_user';

const updateSession = async (refreshToken: string) => {
  return patchRequest<SessionResponse>({
    baseURI: process.env.NEXT_PUBLIC_WAMAZING_API_ENDPOINT || '',
    path,
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
    resource,
  });
};

const deleteSession = async () => {
  deleteRequest({
    baseURI: process.env.NEXT_PUBLIC_WAMAZING_API_ENDPOINT || '',
    path,
  });
};

export { deleteSession, updateSession };
